<p-select
  optionLabel="name"
  filterBy="name"
  [appendTo]="'body'"
  [styleClass]="'w-full'"
  [panelStyle]="{ width: '100%' }"
  [virtualScrollItemSize]="optionHeight"
  [virtualScrollOptions]="virtualScrollOptions"
  [virtualScroll]="true"
  [options]="selectOptions"
  [filter]="true"
  [showClear]="showClear"
  [filterValue]="searchString"
  [loading]="dataLoading"
  placeholder="{{ 'Select one' | translate }}"
  [(ngModel)]="selectedOption"
  (onChange)="onChange($event)"
  (onClear)="onChange()"
  (onFilter)="onFilter()">
  <ng-template #filter>
    <p-iconfield styleClass="w-full" class="w-full">
      <p-inputicon styleClass="pi pi-search" />
      <input
        type="text"
        pInputText
        class="w-full"
        placeholder="{{ 'Type something to start the search' | translate }}"
        [(ngModel)]="searchString"
        (ngModelChange)="onFilter()" />
    </p-iconfield>
  </ng-template>
  <ng-template #selectedItem let-selectedOption>
    <ng-template
      [ngTemplateOutlet]="selectedOptionTemplate || defaultSelectedTemplate"
      [ngTemplateOutletContext]="{ item: selectedOption }" />
  </ng-template>
  <ng-template #item let-option>
    <ng-template
      [ngTemplateOutlet]="optionTemplate || defaultOptionTemplate"
      [ngTemplateOutletContext]="{ item: option }" />
  </ng-template>
</p-select>
@if (dataLoading) {
  <p>{{ 'Loading' | translate }}....</p>
}

<ng-template #defaultOptionTemplate let-item="item">
  <div class="flex items-center">
    <div>{{ item.name }}</div>
  </div>
</ng-template>
<ng-template #defaultSelectedTemplate let-item="item">
  <div class="ml-1">{{ item.name }}</div>
</ng-template>
